//@flow
import {useLocation} from 'react-router-dom';
import React, {useCallback, useState} from 'react';
import {makeStyles, IconButton, MenuItem} from '@material-ui/core';

import FilterMenu from './FilterMenu';
import CustomSelect from '../../../../../../../elements/CustomSelect/CustomSelect';
import {
  useFilterConversationsActions,
  useFilterConversations,
} from '../../../../utils/conversation';
import {debounce} from '../../../../../../../utils/functions';
import SearchInput from '../../../../../../../elements/SearchInput';
import CustomButton from '../../../../../../../elements/CustomButton/CustomButton';
import ModalFilter from './ModalFilter';
import {useToggle} from '../../../../../../../utils/react';
import FilterIcon from '../../../../../../../elements/icons/FilterIcon';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    padding: '.5rem',
  },
  selectsWrap: {
    display: 'flex',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  select: {
    '& > div': {
      border: 'none',
    },
  },
  largeFilterOptions: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      padding: '.5rem',
      whiteSpace: 'nowrap',
      alignItems: 'center',
      overflow: 'hidden',
      justifyContent: 'space-between',
    },
  },
  stateFilterButton: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 0,
  },
  searchInput: {
    width: '100%',
  },
}));

const STATE_FILTER_OPTIONS = [
  {
    label: 'Todos',
    value: 'ALL',
  },
  {
    label: 'Abiertos',
    value: 'OPEN',
  },
];

export default function FilterSection() {
  const classes = useStyles();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const searchValueFromParams = searchParams.get('identifier') || '';

  const {filterByState, filterByIdentifier} = useFilterConversationsActions();
  const {state} = useFilterConversations();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [filtersOpen, toggleFiltersOpen] = useToggle();

  const open = !!anchorEl;

  const handleMenuOpen = event => {
    // setAnchorEl(event.currentTarget);
    toggleFiltersOpen();
  };

  const handleChange = useCallback(
    debounce((value: string) => {
      filterByIdentifier(value);
    }, 500),
    []
  );

  return (
    <>
      <div className={classes.header}>
        <SearchInput
          placeholder="Buscar"
          value={searchValueFromParams}
          onChange={handleChange}
          className={classes.searchInput}
        />
        <div>
          <IconButton
            onClick={handleMenuOpen}
            aria-controls={open ? 'filter-menu' : undefined}
            aria-haspopup="true"
            color="primary"
            aria-expanded={open ? 'true' : undefined}
          >
            <FilterIcon />
          </IconButton>
          <FilterMenu setAnchorEl={setAnchorEl} anchorEl={anchorEl} />
          <ModalFilter
            open={filtersOpen}
            onClose={toggleFiltersOpen}
            onApply={toggleFiltersOpen}
          />
        </div>
      </div>
      <div className={classes.selectsWrap}>
        <CustomSelect
          value={state}
          fullWidth
          pagination
          onChange={e => {
            const value = e.target.value;
            filterByState(value);
          }}
          className={classes.select}
        >
          {STATE_FILTER_OPTIONS.map(({label, value}) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </CustomSelect>
      </div>

      <div className={classes.largeFilterOptions}>
        {STATE_FILTER_OPTIONS.map(({label, value}) => (
          <CustomButton
            key={value}
            variant="text"
            fullWidth
            className={classes.stateFilterButton}
            color={state === value ? 'primary' : 'default'}
            onClick={() => filterByState(value)}
          >
            {label}
          </CustomButton>
        ))}
      </div>
    </>
  );
}
